import { MenuContent } from "./content/content";
import { MenuContentItem } from "./item/item";
import { MenuContentItemContent } from "./item/item.content";
import { MenuContentItemIcon } from "./item/item.icon";
import { MenuContentList } from "./list/list";
import { MenuRoot } from "./root/root";
import { MenuTrigger } from "./trigger/trigger";

const Menu = Object.assign(MenuRoot, {
    Trigger: MenuTrigger,
    Content: Object.assign(MenuContent, {
        List: MenuContentList,
        Item: Object.assign(MenuContentItem, {
            Icon: MenuContentItemIcon,
            Content: MenuContentItemContent,
        }),
    }),
});

export { Menu };

export * from "./root/root";
export * from "./trigger/trigger";
export * from "./content/content";
export * from "./list/list";
export * from "./item/item";
export * from "./item/item.icon";
export * from "./item/item.content";
